import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Table,
  Card,
  Row,
  Col,
  Form,
  Button,
  Modal,
  Spinner,
  Badge,
  Alert,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import {
  FaEye,
  FaFilter,
  FaDownload,
  FaTimes,
  FaCalendarAlt,
  FaSearch,
  FaInfoCircle,
} from "react-icons/fa";
import io from "socket.io-client";
import "./RequestStyle.css";
const Requests = () => {
  const [requests, setRequests] = useState([]);
  const [filteredRequests, setFilteredRequests] = useState([]);
  const [statusCounts, setStatusCounts] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [showScrollButton, setShowScrollButton] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [customMessage, setCustomMessage] = useState("");
  const [selectedComplaint, setSelectedComplaint] = useState(null);

  const [statuses, setStatuses] = useState([]);
  const [mainCategories, setMainCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [subCategories3, setSubCategories3] = useState([]);
  const [selectedMainCategory, setSelectedMainCategory] = useState("");
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [selectedSubCategory3, setSelectedSubCategory3] = useState("");
  const [dateRange, setDateRange] = useState({
    startDate: "",
    endDate: "",
  });

  // For image modal
  const [showImageModal, setShowImageModal] = useState(false);
  const [modalImageSrc, setModalImageSrc] = useState("");
  const [loadingImageTicket, setLoadingImageTicket] = useState(null);
  const [isSending, setIsSending] = useState(false);

  // New state for improved UX
  const [showFilters, setShowFilters] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  const API_URL = process.env.REACT_APP_API_URL;
  const Mobile_API_URL =
    process.env.REACT_APP_MOBILE_API_URL ||
    "https://selfcare.americanholdings.lk";
  const token = localStorage.getItem("authToken");

  // Parse inventory details from request body
  const parseInventoryDetails = (requestBody) => {
    if (!requestBody) return null;

    const currentBottleMatch = requestBody.match(
      /Current Bottle Count:\s*(\d+)/,
    );
    const increaseAmountMatch = requestBody.match(/Increase Amount:\s*(\d+)/);

    if (currentBottleMatch || increaseAmountMatch) {
      return {
        currentBottleCount: currentBottleMatch
          ? parseInt(currentBottleMatch[1])
          : 0,
        increaseAmount: increaseAmountMatch
          ? parseInt(increaseAmountMatch[1])
          : 0,
      };
    }
    return null;
  };

  // Parse new account details from request body
  const parseNewAccountDetails = (requestBody) => {
    if (!requestBody) return null;

    const nameMatch = requestBody.match(/New Account Name:\s*([^-]+)/);
    const addressMatch = requestBody.match(/New Address:\s*([^-]+)/);
    const contactMatch = requestBody.match(/New Contact Number:\s*(\d+)/);

    if (nameMatch || addressMatch || contactMatch) {
      return {
        name: nameMatch ? nameMatch[1].trim() : "",
        address: addressMatch ? addressMatch[1].trim() : "",
        contact: contactMatch ? contactMatch[1].trim() : "",
      };
    }
    return null;
  };

  // Render enhanced request body based on category
  const renderEnhancedRequestBody = (request) => {
    if (request.MCatDesc === "Inventory") {
      const inventoryData = parseInventoryDetails(request.RequesBody);
      if (inventoryData) {
        return (
          <div
            className="inventory-details p-2 bg-light rounded border"
            style={{ minWidth: "220px" }}
          >
            <div className="d-flex align-items-center gap-2 mb-2">
              <i className="fas fa-box text-info"></i>
              <strong className="text-info small">INVENTORY UPDATE</strong>
            </div>
            <div className="row g-1">
              <div className="col-12">
                <div className="d-flex justify-content-between align-items-center p-2 bg-white rounded mb-1">
                  <div className="d-flex align-items-center gap-2">
                    <div
                      className="bg-info rounded-circle d-flex align-items-center justify-content-center"
                      style={{ width: "20px", height: "20px" }}
                    >
                      <small
                        className="text-white fw-bold"
                        style={{ fontSize: "10px" }}
                      >
                        C
                      </small>
                    </div>
                    <span className="small text-muted">Current</span>
                  </div>
                  <span className="fw-bold text-primary fs-6">
                    {inventoryData.currentBottleCount}
                  </span>
                </div>
              </div>
              <div className="col-12">
                <div className="d-flex justify-content-between align-items-center p-2 bg-white rounded mb-1">
                  <div className="d-flex align-items-center gap-2">
                    <div
                      className="bg-success rounded-circle d-flex align-items-center justify-content-center"
                      style={{ width: "20px", height: "20px" }}
                    >
                      <small
                        className="text-white fw-bold"
                        style={{ fontSize: "10px" }}
                      >
                        +
                      </small>
                    </div>
                    <span className="small text-muted">Increase</span>
                  </div>
                  <span className="fw-bold text-success fs-6">
                    +{inventoryData.increaseAmount}
                  </span>
                </div>
              </div>
            </div>
          </div>
        );
      }
    }

    if (request.MCatDesc === "New Account") {
      const accountData = parseNewAccountDetails(request.RequesBody);
      if (accountData) {
        return (
          <div
            className="account-details p-2 bg-light rounded border"
            style={{ minWidth: "250px" }}
          >
            <div className="d-flex align-items-center gap-2 mb-2">
              <i className="fas fa-user-plus text-success"></i>
              <strong className="text-success small">
                NEW ACCOUNT REQUEST
              </strong>
            </div>
            <div className="d-flex flex-column gap-2">
              {accountData.name && (
                <div className="d-flex align-items-center p-2 bg-white rounded">
                  <div
                    className="d-flex align-items-center"
                    style={{ minWidth: "70px" }}
                  >
                    <div
                      className="bg-primary rounded-circle d-flex align-items-center justify-content-center me-2"
                      style={{ width: "18px", height: "18px" }}
                    >
                      <i
                        className="fas fa-user text-white"
                        style={{ fontSize: "8px" }}
                      ></i>
                    </div>
                    <span className="small text-muted fw-semibold">Name:</span>
                  </div>
                  <span className="small fw-bold text-dark ms-2 flex-grow-1">
                    {accountData.name}
                  </span>
                </div>
              )}
              {accountData.address && (
                <div className="d-flex align-items-start p-2 bg-white rounded">
                  <div
                    className="d-flex align-items-center"
                    style={{ minWidth: "70px" }}
                  >
                    <div
                      className="bg-secondary rounded-circle d-flex align-items-center justify-content-center me-2"
                      style={{ width: "18px", height: "18px" }}
                    >
                      <i
                        className="fas fa-map-marker-alt text-white"
                        style={{ fontSize: "8px" }}
                      ></i>
                    </div>
                    <span className="small text-muted fw-semibold">
                      Address:
                    </span>
                  </div>
                  <span
                    className="small text-dark ms-2 flex-grow-1"
                    style={{ lineHeight: "1.2" }}
                  >
                    {accountData.address}
                  </span>
                </div>
              )}
              {accountData.contact && (
                <div className="d-flex align-items-center p-2 bg-white rounded">
                  <div
                    className="d-flex align-items-center"
                    style={{ minWidth: "70px" }}
                  >
                    <div
                      className="bg-success rounded-circle d-flex align-items-center justify-content-center me-2"
                      style={{ width: "18px", height: "18px" }}
                    >
                      <i
                        className="fas fa-phone text-white"
                        style={{ fontSize: "8px" }}
                      ></i>
                    </div>
                    <span className="small text-muted fw-semibold">Phone:</span>
                  </div>
                  <span className="small fw-bold text-success ms-2 flex-grow-1 font-monospace">
                    {accountData.contact}
                  </span>
                </div>
              )}
            </div>
          </div>
        );
      }
    }

    // Default display for other categories
    return (
      <div style={{ maxWidth: "250px", minWidth: "150px" }}>
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip
              id={`tooltip-${request.TicketNo}`}
              className="custom-tooltip"
            >
              <div style={{ maxWidth: "300px", fontSize: "12px" }}>
                <strong>Full Request Details:</strong>
                <br />
                {request.RequesBody}
              </div>
            </Tooltip>
          }
        >
          <div
            className="p-2 bg-light rounded border"
            style={{ cursor: "pointer" }}
          >
            <div className="d-flex align-items-center gap-2 mb-1">
              <i className="fas fa-file-alt text-muted"></i>
              <small className="text-muted fw-semibold">REQUEST DETAILS</small>
            </div>
            <p
              className="mb-0 small text-dark"
              style={{
                display: "-webkit-box",
                WebkitLineClamp: 3,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                lineHeight: "1.3",
              }}
            >
              {request.RequesBody}
            </p>
          </div>
        </OverlayTrigger>
      </div>
    );
  };

  // Existing useEffects remain the same...
  useEffect(() => {
    const fetchStatuses = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/requests/status`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setStatuses(response.data);
      } catch (err) {
        setError("Failed to fetch status list.");
      }
    };
    fetchStatuses();
  }, [token, API_URL]);

  useEffect(() => {
    const fetchMainCategories = async () => {
      try {
        const response = await axios.get(
          `${API_URL}/api/requests/categories/main`,
          { headers: { Authorization: `Bearer ${token}` } },
        );
        setMainCategories(response.data);
      } catch (err) {
        console.error("Failed to fetch main categories:", err);
      }
    };
    fetchMainCategories();
  }, [token, API_URL]);

  useEffect(() => {
    const fetchSubCategories = async () => {
      if (selectedMainCategory) {
        try {
          const response = await axios.get(
            `${API_URL}/api/requests/subcategories/${selectedMainCategory}`,
            { headers: { Authorization: `Bearer ${token}` } },
          );
          setSubCategories(response.data);
          setSelectedSubCategory("");
          setSubCategories3([]);
          setSelectedSubCategory3("");
        } catch (err) {
          console.error("Failed to fetch sub-categories:", err);
        }
      } else {
        setSubCategories([]);
        setSelectedSubCategory("");
        setSubCategories3([]);
        setSelectedSubCategory3("");
      }
    };
    fetchSubCategories();
  }, [selectedMainCategory, token, API_URL]);

  useEffect(() => {
    const fetchSubCategories3 = async () => {
      if (selectedMainCategory && selectedSubCategory) {
        try {
          const response = await axios.get(
            `${API_URL}/api/requests/subcategory3/${selectedMainCategory}/${selectedSubCategory}`,
            { headers: { Authorization: `Bearer ${token}` } },
          );
          setSubCategories3(response.data);
          setSelectedSubCategory3("");
        } catch (err) {
          console.error("Failed to fetch sub-category 3:", err);
        }
      } else {
        setSubCategories3([]);
        setSelectedSubCategory3("");
      }
    };
    fetchSubCategories3();
  }, [selectedMainCategory, selectedSubCategory, token, API_URL]);

  useEffect(() => {
    const handleScroll = () => setShowScrollButton(window.scrollY > 300);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    let socket;

    const fetchRequests = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await axios.get(`${API_URL}/api/requests`, {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            startDate: dateRange.startDate,
            endDate: dateRange.endDate,
          },
        });
        const sorted = response.data.sort(
          (a, b) => new Date(b.RecordedDate) - new Date(a.RecordedDate),
        );
        setRequests(sorted);
        setFilteredRequests(sorted);
        setCurrentPage(1); // Reset to first page when data changes

        if (statuses.length > 0) {
          updateStatusCounts(sorted, statuses);
        }
      } catch (err) {
        setError("Failed to fetch requests.");
      }
      setLoading(false);
    };

    if (dateRange.startDate && dateRange.endDate && statuses.length > 0) {
      fetchRequests();
      if (API_URL) {
        socket = io(API_URL);
        socket.on("requestsUpdated", () => {
          console.log("🔄 Requests update received via WebSocket.");
          fetchRequests();
        });
      }
    } else {
      setRequests([]);
      setFilteredRequests([]);
      setStatusCounts({});
    }

    return () => {
      if (socket) {
        socket.off("requestsUpdated");
        socket.disconnect();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [API_URL, token, statuses, dateRange.startDate, dateRange.endDate]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!dateRange.startDate || !dateRange.endDate) {
      setFilteredRequests([]);
      return;
    }
    applyFilters();
  }, [
    searchQuery,
    selectedStatus,
    selectedMainCategory,
    selectedSubCategory,
    selectedSubCategory3,
    dateRange,
    requests,
  ]);

  // Get background color based on status
  const getStatusBgColor = (status) => {
    switch (status) {
      case "Pending":
        return "warning";
      case "Completed":
        return "success";
      case "Rejected":
        return "#f8d7da";
      case "Forwarded To Marketing":
        return "#e2e3e5";
      case "Forwarded To Operation":
        return "#cce5ff";
      case "Deleted":
        return "#ffebee";
      default:
        return "#ffffff";
    }
  };

  // Apply all filters
  const applyFilters = () => {
    let filtered = [...requests];

    if (selectedStatus) {
      filtered = filtered.filter((r) => r.ReqStatusDesc === selectedStatus);
    }
    if (searchQuery) {
      filtered = filtered.filter((r) =>
        [
          r.CusID,
          r.CustomerCode,
          r.BranchCode,
          r.RouteCode,
          r.OfficeLocation,
          r.MCatDesc,
          r.SCatDesc,
          r.SCat3Desc,
          r.RequesBody,
        ].some(
          (field) =>
            field &&
            String(field).toLowerCase().includes(searchQuery.toLowerCase()),
        ),
      );
    }
    if (selectedMainCategory) {
      filtered = filtered.filter((r) => r.MainCatID === selectedMainCategory);
    }
    if (selectedSubCategory) {
      filtered = filtered.filter((r) => r.SubCatID === selectedSubCategory);
    }
    if (selectedSubCategory3) {
      filtered = filtered.filter((r) => r.SubCat3ID === selectedSubCategory3);
    }
    if (dateRange.startDate && dateRange.endDate) {
      const startDate = new Date(dateRange.startDate);
      const endDate = new Date(dateRange.endDate);
      filtered = filtered.filter((r) => {
        const recordDate = new Date(r.RecordedDate);
        return recordDate >= startDate && recordDate <= endDate;
      });
    }

    setFilteredRequests(filtered);
    setCurrentPage(1); // Reset to first page when filters change
    updateStatusCounts(filtered, statuses);
  };

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredRequests.slice(
    indexOfFirstItem,
    indexOfLastItem,
  );
  const totalPages = Math.ceil(filteredRequests.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Filter by status
  const handleStatusFilter = (status) => {
    setSelectedStatus(status === selectedStatus ? "" : status);
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleMainCategoryChange = (e) => {
    setSelectedMainCategory(e.target.value);
  };

  const handleSubCategoryChange = (e) => {
    setSelectedSubCategory(e.target.value);
  };

  const handleSubCategory3Change = (e) => {
    setSelectedSubCategory3(e.target.value);
  };

  const handleDateRangeChange = (e) => {
    const { name, value } = e.target;
    setDateRange((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const clearFilters = () => {
    setSearchQuery("");
    setSelectedStatus("");
    setSelectedMainCategory("");
    setSelectedSubCategory("");
    setSelectedSubCategory3("");
  };

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  // Rest of your existing functions remain the same...
  const sendNotification = async (requestId, customerId, customMessage) => {
    try {
      const url = `${Mobile_API_URL}/api/FirebasePushNotifications/resolveRequestAndNotify?requestId=${requestId}&customerId=${customerId}&customMessage=${encodeURIComponent(
        customMessage,
      )}`;
      await axios.post(url, null, {
        headers: { Authorization: `Bearer ${token}` },
      });

      Swal.fire("Notification Sent", "Customer has been notified.", "success");
    } catch (error) {
      Swal.fire(
        "Notification Failed",
        error.response?.data?.message || error.message,
        "error",
      );
    }
  };

  const updateStatus = async (requestId, newStatus) => {
    try {
      await axios.put(
        `${API_URL}/api/requests/status/${requestId}`,
        { TicketStatus: newStatus },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      const statusObj = statuses.find((s) => s.ReqStatusID === newStatus);
      const newStatusName = statusObj ? statusObj.ReqStatusDesc : "Unknown";

      const updated = requests.map((r) =>
        r.TicketNo === requestId
          ? {
              ...r,
              ReqStatusDesc: newStatusName,
              // Hide proof image after request is completed
              ...(newStatusName === "Completed" ? { FilePath: null } : {}),
            }
          : r,
      );

      setRequests(updated);
      setFilteredRequests(updated);
      updateStatusCounts(updated, statuses);

      Swal.fire("Success", "Status updated successfully.", "success");
    } catch (err) {
      Swal.fire("Error", "Failed to update status.", "error");
    }
  };

  const updateStatusCounts = (data, statusesArr) => {
    const counts = (statusesArr || statuses).reduce((acc, status) => {
      acc[status.ReqStatusDesc] = data.filter(
        (r) => r.ReqStatusDesc === status.ReqStatusDesc,
      ).length;
      return acc;
    }, {});
    setStatusCounts(counts);
  };

  const handleStatusChange = (requestId, newStatus, customerId) => {
    const numericStatus = parseInt(newStatus);
    if (numericStatus === 2) {
      setSelectedComplaint({ complaintId: requestId, customerId });
      setShowModal(true);
    } else {
      updateStatus(requestId, numericStatus);
    }
  };

  const handleSubmitResolved = async () => {
    if (customMessage.trim() && selectedComplaint) {
      setIsSending(true);

      try {
        const { complaintId, customerId } = selectedComplaint;
        await sendNotification(complaintId, customerId, customMessage);
        await updateStatus(complaintId, 2);

        setShowModal(false);
        setCustomMessage("");
        setSelectedComplaint(null);
      } catch (error) {
        console.error("Error sending notification:", error);
        Swal.fire(
          "Error",
          "Something went wrong while sending the notification.",
          "error",
        );
      } finally {
        setIsSending(false);
      }
    } else {
      Swal.fire("Warning", "Custom message is required.", "warning");
    }
  };

  const exportToExcel = () => {
    const exportData = filteredRequests.map((request) => ({
      "Ticket No": request.TicketNo,
      "Customer ID": request.CusID,
      "Customer Code": request.CustomerCode,
      "Branch Code": request.BranchCode,
      "Main Category": request.MCatDesc,
      "Sub Category": request.SCatDesc,
      "Sub Category 3": request.SCat3Desc,
      "Request Body": request.RequesBody,
      "Recorded Date": new Date(request.RecordedDate).toLocaleDateString(),
      Status: request.ReqStatusDesc,
      "Completed Date": request.CompletedDate
        ? new Date(request.CompletedDate).toLocaleDateString("en-GB")
        : "N/A",
      "Completed By": request.CompletedBy,
      Remarks: request.Remarks,
    }));

    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Requests");
    XLSX.writeFile(wb, "Requests.xlsx");
  };

  const handleImageModalClose = () => {
    setShowImageModal(false);
    setModalImageSrc("");
  };

  const handleImageClick = async (ticketNo) => {
    setLoadingImageTicket(ticketNo);

    try {
      const response = await axios.get(
        `${Mobile_API_URL}/api/FileUpload/get-encrypted-file/by-ticket/${ticketNo}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        },
      );

      const fileBlob = new Blob([response.data]);
      const fileUrl = URL.createObjectURL(fileBlob);
      setModalImageSrc(fileUrl);
      setShowImageModal(true);
    } catch (error) {
      console.error("Failed to fetch encrypted file:", error);
      Swal.fire({
        icon: "error",
        title: "Failed to Load File",
        text:
          error.response?.data?.message ||
          "Something went wrong while fetching the file.",
        confirmButtonColor: "#d33",
      });
    } finally {
      setLoadingImageTicket(null);
    }
  };

  const handleLastMonthClick = () => {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    const end = tomorrow.toISOString().split("T")[0];

    const pastMonth = new Date();
    pastMonth.setMonth(pastMonth.getMonth() - 1);
    const start = pastMonth.toISOString().split("T")[0];

    setDateRange({
      startDate: start,
      endDate: end,
    });
  };

  return (
    <div className="page">
      {/* Header with improved styling */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2 className="mb-1 text-primary">Request Management</h2>
          <p className="text-muted mb-0">
            Manage and track customer requests efficiently
          </p>
        </div>
        {filteredRequests.length > 0 && (
          <Badge bg="info" className="fs-6 px-3 py-2">
            {filteredRequests.length} Total Records
          </Badge>
        )}
      </div>

      {/* Date Selection Card with improved UI */}
      <Card className="mb-4 shadow-sm border-0">
        <Card.Header className="bg-light border-0">
          <div className="d-flex align-items-center gap-2">
            <FaCalendarAlt className="text-primary" />
            <h6 className="mb-0 fw-semibold">Date Range Selection</h6>
            <Badge bg="warning" className="ms-2">
              Required
            </Badge>
          </div>
        </Card.Header>
        <Card.Body>
          <Row className="align-items-end g-3">
            <Col md={3}>
              <Form.Group>
                <Form.Label className="fw-semibold">Start Date</Form.Label>
                <Form.Control
                  type="date"
                  name="startDate"
                  value={dateRange.startDate}
                  onChange={handleDateRangeChange}
                  size="sm"
                  max={dateRange.endDate}
                  className="border-2"
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label className="fw-semibold">End Date</Form.Label>
                <Form.Control
                  type="date"
                  name="endDate"
                  value={dateRange.endDate}
                  onChange={handleDateRangeChange}
                  size="sm"
                  min={dateRange.startDate}
                  className="border-2"
                />
              </Form.Group>
            </Col>
            <Col md="auto">
              <Button
                size="sm"
                variant="outline-primary"
                onClick={handleLastMonthClick}
                className="d-flex align-items-center gap-2"
              >
                <FaCalendarAlt />
                Last 1 Month
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {!dateRange.startDate || !dateRange.endDate ? (
        <Alert variant="info" className="text-center py-5">
          <FaInfoCircle size={48} className="mb-3 text-info" />
          <h5>Select Date Range</h5>
          <p className="mb-0">
            Please select both start and end dates to view requests.
          </p>
        </Alert>
      ) : loading || statuses.length === 0 ? (
        <div className="text-center py-5">
          <Spinner animation="border" variant="primary" size="lg" />
          <p className="mt-3 text-muted">Loading requests...</p>
        </div>
      ) : error ? (
        <Alert variant="danger">{error}</Alert>
      ) : (
        <>
          {/* Enhanced Status Cards */}
          <Row className="mb-4 g-3">
            {statuses.map((status) => {
              const count = statusCounts[status.ReqStatusDesc] || 0;
              const isSelected = selectedStatus === status.ReqStatusDesc;

              return (
                <Col md={2} key={status.ReqStatusID}>
                  <Card
                    onClick={() => handleStatusFilter(status.ReqStatusDesc)}
                    className={`shadow-sm h-100 ${isSelected ? "border-primary border-2" : ""}`}
                    style={{
                      cursor: "pointer",
                      transition: "all 0.2s",
                      transform: isSelected ? "translateY(-2px)" : "none",
                    }}
                  >
                    <Card.Body className="text-center py-3">
                      <h6
                        className="mb-2 fw-semibold"
                        style={{ fontSize: "0.9rem" }}
                      >
                        {status.ReqStatusDesc}
                      </h6>
                      <div className="d-flex align-items-center justify-content-center">
                        <span className="h4 mb-0 fw-bold text-primary">
                          {count}
                        </span>
                        {isSelected && (
                          <Badge bg="primary" className="ms-2">
                            Active
                          </Badge>
                        )}
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              );
            })}
          </Row>

          {/* Collapsible Advanced Filters */}
          <Card className="mb-4 shadow-sm border-0">
            <Card.Header className="bg-light border-0">
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center gap-2">
                  <FaFilter className="text-primary" />
                  <h6 className="mb-0 fw-semibold">Filters & Search</h6>
                </div>
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={() => setShowFilters(!showFilters)}
                >
                  {showFilters ? "Hide Advanced" : "Show Advanced"}
                </Button>
              </div>
            </Card.Header>
            <Card.Body>
              {/* Always visible search */}
              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group>
                    <div className="position-relative">
                      <FaSearch className="position-absolute top-50 start-0 translate-middle-y ms-3 text-muted" />
                      <Form.Control
                        placeholder="Search by any field (Customer Code, Branch, Route, etc.)"
                        value={searchQuery}
                        onChange={handleSearch}
                        size="sm"
                        className="ps-5 border-2"
                      />
                    </div>
                  </Form.Group>
                </Col>
              </Row>

              {/* Advanced filters - collapsible */}
              {showFilters && (
                <Row className="g-3">
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">
                        Main Category
                      </Form.Label>
                      <Form.Select
                        value={selectedMainCategory}
                        onChange={handleMainCategoryChange}
                        size="sm"
                        className="border-2"
                      >
                        <option value="">All Main Categories</option>
                        {mainCategories.map((cat) => (
                          <option key={cat.MCatID} value={cat.MCatID}>
                            {cat.MCatDesc}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">
                        Sub Category
                      </Form.Label>
                      <Form.Select
                        value={selectedSubCategory}
                        onChange={handleSubCategoryChange}
                        disabled={!selectedMainCategory}
                        size="sm"
                        className="border-2"
                      >
                        <option value="">All Sub Categories</option>
                        {subCategories.map((subCat) => (
                          <option key={subCat.SCatID} value={subCat.SCatID}>
                            {subCat.SCatDesc}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">
                        Sub Category 3
                      </Form.Label>
                      <Form.Select
                        value={selectedSubCategory3}
                        onChange={handleSubCategory3Change}
                        disabled={!selectedSubCategory}
                        size="sm"
                        className="border-2"
                      >
                        <option value="">All Sub Categories 3</option>
                        {subCategories3.map((subCat3) => (
                          <option key={subCat3.SCat3ID} value={subCat3.SCat3ID}>
                            {subCat3.SCat3Desc}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={3} className="d-flex align-items-end">
                    <Button
                      variant="outline-secondary"
                      onClick={clearFilters}
                      size="sm"
                      className="d-flex align-items-center gap-2 w-100"
                    >
                      <FaTimes />
                      Clear Filters
                    </Button>
                  </Col>
                </Row>
              )}

              <Row className="mt-3">
                <Col className="d-flex justify-content-end">
                  <Button
                    variant="success"
                    onClick={exportToExcel}
                    size="sm"
                    className="d-flex align-items-center gap-2"
                  >
                    <FaDownload />
                    Export to Excel
                  </Button>
                </Col>
              </Row>
            </Card.Body>
          </Card>

          {/* Enhanced Table with better styling */}
          <div className="table-responsive">
            {filteredRequests.length === 0 ? (
              <Alert variant="info" className="text-center py-4">
                <h5>📭 No requests found</h5>
                <p>No requests were found matching your filters.</p>
              </Alert>
            ) : (
              <>
                <Table
                  striped
                  bordered
                  hover
                  responsive
                  className="mb-0 shadow-sm"
                  style={{ minWidth: "1400px" }}
                >
                  <thead className="table-dark sticky-top">
                    <tr>
                      <th>Ticket No</th>
                      <th>Customer</th>
                      <th>Location</th>
                      <th>Date</th>
                      <th>Category</th>
                      <th>Description</th>
                      <th>Status</th>
                      <th>Completed</th>
                      <th>Image</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems.map((request) => (
                      <tr key={request.TicketNo}>
                        <td>
                          <Badge bg="secondary" className="font-monospace">
                            #{request.TicketNo}
                          </Badge>
                        </td>
                        <td>
                          <div>
                            <div className="fw-semibold">
                              {request.CustomerCode}
                            </div>
                            <small className="text-muted">
                              Branch: {request.BranchCode}
                            </small>
                          </div>
                        </td>
                        <td>
                          <div>
                            <div>{request.OfficeLocation}</div>
                            <small className="text-muted">
                              Route: {request.RouteCode}
                            </small>
                          </div>
                        </td>
                        <td>
                          {request.RecordedDate
                            ? new Date(request.RecordedDate).toLocaleDateString(
                                "en-GB",
                              )
                            : "N/A"}
                        </td>
                        <td>
                          <div>
                            <Badge
                              bg={
                                request.MCatDesc === "Inventory"
                                  ? "info"
                                  : request.MCatDesc === "New Account"
                                    ? "success"
                                    : "secondary"
                              }
                              className="mb-1"
                            >
                              {request.MCatDesc}
                            </Badge>
                            {request.SCatDesc && (
                              <div>
                                <Badge bg="secondary" className="small">
                                  {request.SCatDesc}
                                </Badge>
                              </div>
                            )}
                            {request.SCat3Desc && (
                              <div>
                                <Badge bg="light" text="dark" className="small">
                                  {request.SCat3Desc}
                                </Badge>
                              </div>
                            )}
                          </div>
                        </td>
                        <td style={{ maxWidth: "250px" }}>
                          {renderEnhancedRequestBody(request)}
                        </td>
                        <td>
                          <Form.Select
                            value={
                              statuses.find(
                                (s) =>
                                  s.ReqStatusDesc === request.ReqStatusDesc,
                              )?.ReqStatusID || ""
                            }
                            onChange={(e) =>
                              handleStatusChange(
                                request.TicketNo,
                                e.target.value,
                                request.CusID,
                              )
                            }
                            disabled={
                              request.ReqStatusDesc === "Deleted" ||
                              request.ReqStatusDesc === "Completed"
                            }
                            className={`border-2 bg-${getStatusBgColor(request.ReqStatusDesc)}`}
                            size="sm"
                          >
                            {statuses.map((s) => (
                              <option key={s.ReqStatusID} value={s.ReqStatusID}>
                                {s.ReqStatusDesc}
                              </option>
                            ))}
                          </Form.Select>
                        </td>
                        <td>
                          {request.CompletedDate ? (
                            <span className="text-success">
                              ✅{" "}
                              {new Date(
                                request.CompletedDate,
                              ).toLocaleDateString("en-GB")}
                              {request.CompletedBy && (
                                <small className="d-block text-muted">
                                  by {request.CompletedBy}
                                </small>
                              )}
                            </span>
                          ) : (
                            <span className="text-muted">Pending</span>
                          )}
                        </td>
                        <td className="text-center">
                          {request.FilePath &&
                          request.ReqStatusDesc !== "Completed" ? (
                            <Button
                              onClick={() => handleImageClick(request.TicketNo)}
                              size="sm"
                              variant="outline-primary"
                              disabled={loadingImageTicket === request.TicketNo}
                              style={{ minWidth: "40px", minHeight: "32px" }}
                            >
                              {loadingImageTicket === request.TicketNo ? (
                                <Spinner size="sm" animation="border" />
                              ) : (
                                <FaEye />
                              )}
                            </Button>
                          ) : (
                            <span className="text-muted">-</span>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>

                {/* Pagination */}
                {totalPages > 1 && (
                  <div className="d-flex justify-content-center align-items-center gap-3 mt-4">
                    <Button
                      variant="outline-primary"
                      size="sm"
                      disabled={currentPage === 1}
                      onClick={() => handlePageChange(currentPage - 1)}
                    >
                      ← Previous
                    </Button>

                    <div className="d-flex gap-1">
                      {[...Array(totalPages)].map((_, index) => {
                        const pageNum = index + 1;
                        if (
                          pageNum === 1 ||
                          pageNum === totalPages ||
                          (pageNum >= currentPage - 2 &&
                            pageNum <= currentPage + 2)
                        ) {
                          return (
                            <Button
                              key={pageNum}
                              variant={
                                currentPage === pageNum
                                  ? "primary"
                                  : "outline-primary"
                              }
                              size="sm"
                              onClick={() => handlePageChange(pageNum)}
                              style={{ minWidth: "40px" }}
                            >
                              {pageNum}
                            </Button>
                          );
                        } else if (
                          pageNum === currentPage - 3 ||
                          pageNum === currentPage + 3
                        ) {
                          return <span key={pageNum}>...</span>;
                        }
                        return null;
                      })}
                    </div>

                    <Button
                      variant="outline-primary"
                      size="sm"
                      disabled={currentPage === totalPages}
                      onClick={() => handlePageChange(currentPage + 1)}
                    >
                      Next →
                    </Button>
                  </div>
                )}
              </>
            )}
          </div>
        </>
      )}

      {/* Floating scroll to top button */}
      {showScrollButton && (
        <Button
          className="position-fixed shadow-lg"
          style={{
            bottom: "30px",
            right: "30px",
            zIndex: 9999,
            width: "50px",
            height: "50px",
            borderRadius: "50%",
            fontSize: "20px",
          }}
          onClick={scrollToTop}
          title="Scroll to top"
          aria-label="Scroll to top"
        >
          ↑
        </Button>
      )}

      {/* Enhanced Modal for custom message */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="md"
        centered
      >
        <Modal.Header closeButton className="bg-primary text-white">
          <Modal.Title>
            <div className="d-flex align-items-center gap-2">
              <FaInfoCircle />
              Resolve Request & Notify Customer
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert variant="info" className="small">
            <strong>Note:</strong> This message will be sent as a push
            notification to the customer's mobile device.
          </Alert>
          <Form.Group>
            <Form.Label className="fw-semibold">
              Custom Resolution Message
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={customMessage}
              onChange={(e) => setCustomMessage(e.target.value)}
              placeholder="Enter a detailed message about how the request was resolved..."
              className="border-2"
            />
            <Form.Text className="text-muted">
              Characters: {customMessage.length}
            </Form.Text>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-secondary"
            onClick={() => setShowModal(false)}
          >
            Cancel
          </Button>
          <Button
            variant="success"
            onClick={handleSubmitResolved}
            disabled={isSending || !customMessage.trim()}
            className="d-flex align-items-center gap-2"
          >
            {isSending ? (
              <>
                <Spinner size="sm" animation="border" />
                Sending...
              </>
            ) : (
              <>
                <FaInfoCircle />
                Send Notification & Mark Complete
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Enhanced Modal for image view */}
      <Modal
        show={showImageModal}
        onHide={handleImageModalClose}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Request Attachment</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center p-4">
          {modalImageSrc && (
            <img
              src={modalImageSrc}
              alt="Request Attachment"
              style={{
                maxWidth: "100%",
                maxHeight: "70vh",
                borderRadius: "8px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              }}
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleImageModalClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Requests;
